export default __webpack_public_path__ + "static/media/Lorena_porte_cle.fd1dae88.png";